import { appendReduxParts } from "infrastructure/store";

import { appSaga as messageTranslationsSaga } from "../message-details/message-translations/MessageTranslations.saga";
import { messageTranslations } from "../message-details/message-translations/MessageTranslations.slice";

import { AllMessageTranslations } from "./all-translations";
import Messages from "./Messages";
import { messagesManagerSaga } from "./Messages.saga";
import { messagesManager } from "./Messages.slice";
import { messagesUploadSaga } from "./upload/MessagesUpload.saga";
import { messagesUploadManager } from "./upload/MessagesUpload.slice";

export * from "./Messages.actions";
export * from "./Messages.state";
export { Messages };
export { AllMessageTranslations };

appendReduxParts(
  [
    {
      reducerName: messagesManager.name,
      reducer: messagesManager.reducer
    },
    {
      reducerName: messagesUploadManager.name,
      reducer: messagesUploadManager.reducer
    },
    {
      reducerName: messageTranslations.name,
      reducer: messageTranslations.reducer
    }
  ],
  [messagesManagerSaga(), messagesUploadSaga(), messageTranslationsSaga()]
);
